<template>

<div class="breadcrumb">

    <span
        class="link"
        @click="goHome"
    >
        首页
    </span>

    <span class="separator">
        /
    </span>

    <span class="current">
        {{ title }}
    </span>

</div>

</template>

<script>

export default {

    props:{

        title:{
            type:String,
            default:''
        }

    },

    methods:{

        goHome(){

            this.$router.push('/')

        }

    }

}

</script>

<style scoped>

.breadcrumb{

    margin-bottom:16px;

    font-size:14px;

    display:flex;

    align-items:center;

    gap:8px;

}

.link{

    color:#c00000;

    cursor:pointer;

    font-weight:600;

}

.link:hover{

    color:#a50000;

}

.separator{

    color:#999;

}

.current{

    color:#666;

}

</style>